module.exports = __webpack_public_path__ + "assets/img/777.bc77c3fe.png";